import React, { Component } from "react";
import PropTypes from "prop-types";
import "bootstrap";
import { connect } from "react-redux";

class AuctionItems extends Component {

  render() {
    return (
      <div>AuctionItems
      </div>
    );
  }
}

AuctionItems.propTypes = {
  dispatch: PropTypes.func.isRequired
};


AuctionItems.defaultProps = {
  //myProp: <defaultValue>
};

function mapStateToProps(state, ownProps) {
  return {
    state: state
  };
}

export default connect(mapStateToProps)(AuctionItems);